<template>
  <d2-container>
    <div>
      <d2-route-list v-model="info.active" :active='active' :menu="menu" :name="info.name" :enName="info.enName"
        :menuselect='menuselect' @message="changeHandle">
      </d2-route-list>
      <template v-if="info.type == 'richText'">
        <template v-if="info.code == 'pdfOpera'">
          <pdf-opera :code="info.code" :checked="checked" :content="content" :name="info.name" :menu="menu"
            @message="changeHandle"></pdf-opera>
        </template>
        <template v-else>
          <rich-text :code="info.code" :checked="checked" :content="content" :name="info.name" :menu="menu"
            @message="changeHandle"></rich-text>
        </template>
      </template>
      <template v-else-if="info.type == 'list'">
        <template v-if="info.code == 'textList'">
          <list-text :code="info.code" :checked="checked" :ListData="ListData" :readData="readData" :loading="loading"
            @message="messageReloadHandle"></list-text>
        </template>
        <template v-if="info.code == 'piclist'">
          <el-form size="small" class="d2-mt-20" :inline="false" :model="searchForm" ref="searchForm"
            @submit.native.prevent>
            <el-input placeholder="请输入关键字搜索" v-model="searchForm.keyWords" class="input-with-select"
              style="width: 400px" @keyup.enter.native="handleSearchFormSubmit(searchForm.keyWords)">
              <el-button slot="append" icon="el-icon-search" @click="handleSearchFormSubmit(searchForm.keyWords)">
              </el-button>
            </el-input>
          </el-form>
          <list-picture :code="info.code" :ListData="ListData" :readData="readData" :total="total" :loading="loading"
            @message="changeHandle"></list-picture>
        </template>
        <template v-if="info.code == 'pdflist'">
          <list-pdf :code="info.code" :ListData="ListData" :readData="ListData" :total="total" :loading="loading"
            @message="changeHandle"></list-pdf>
        </template>
        <template v-if="info.code == 'activitylist'">
          <list-active :code="info.code" :checked="checked" :ListData="ListData" :total="total" :loading="loading"
            @message="handleClick" @search="handleSearchSubmit" @searchyear="handleSearchYearSubmit"></list-active>
        </template>
        <template v-if="info.code == 'message'">
          <list-message :code="info.code" :ListData="ListData" :loading="loading" @message="messageReloadHandle">
          </list-message>
        </template>
        <template v-if="info.code == 'welfare'">
          <list-welfare :code="info.code" :ListData="ListData" :loading="loading" :total='total'>
          </list-welfare>
        </template>
        <template v-if="info.code == 'points'">
          <list-points :code="info.code" :checked="checked" :ListData="ListData" :loading="loading" :total='total'
            @searchyear="handleSearchYearSubmit1">
          </list-points>
        </template>
        <template v-if="info.code == 'comment'">
          <list-comment :code="info.code" :checked="checked" :ListData="ListData" :loading="loading"
            @message="handlePublish">
          </list-comment>
        </template>
        <template v-if="info.code == 'roster'">
          <list-roster :code="info.code" :checked="checked" :ListData="ListData" :loading="loading"
            @search="handleSearchSubmit">
          </list-roster>
        </template>
        <template v-if="info.code == 'line'">
          <list-line :code="info.code" :checked="checked" :ListData="ListData" :readData='readData' :loading="loading"
            @search="handleSearchLine">
          </list-line>
        </template>
      </template>
      <template v-if="info.type == 'form'">
        <template v-if="info.code == 'info'">
          <my-info :code="info.code" :mainData="mainData" :childrenData="childrenData" :options="options"
            :formStatus="formStatus" :formReadOnly='formReadOnly' :checked="checked" :flowRecord="flowRecord" :loading="loading"
            @message="MemberInfoHandle"></my-info>
        </template>
      </template>
      <div class="scroll_top">

      </div>
    </div>
  </d2-container>
</template>

<script>
  import _ from "lodash";
  import dayjs from "dayjs";
  import * as indexService from "@/api/sys/index";
  import {
    mapState,
    mapActions
  } from "vuex";
  import richTextData from "@/libs/richTextData";
  import richText from "../common/richText";
  import pdfOpera from "../common/pdfOpera";
  import listText from "../common/listText";
  import listPicture from "../common/listPicture";
  import listPdf from "../common/listPdf";
  import listActive from "../common/listActive";
  import listMessage from "../common/listMessage";
  import listWelfare from "../common/listWelfare";
  import listPoints from "../common/listPoints";
  import myInfo from "../common/myInfo";
  import listComment from "../common/listComment"
  import listRoster from "../common/listRoster";
  import listLine from "../common/listLine";
  import rules from "@/libs/rules";
  export default {
    name: "listIndex",
    props: {
      menuselect: {
        type: String,
        required: false,
        default: "",
      },
      active: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    mixins: [rules],
    components: {
      richText,
      pdfOpera,
      listText,
      listPicture,
      listPdf,
      listActive,
      listMessage,
      myInfo,
      listWelfare,
      listPoints,
      listComment,
      listRoster,
      listLine,
    },
    data() {
      return {
        loading: false,
        finished: false,
        ListData: [],
        readData: [],
        menu: [],
        content: "",
        pageIndex: 0,
        total: 0,
        searchForm: {
          keyWords: "",
          searchYear: dayjs().format("YYYY"),
        },
        searchRosterForm: {
          keyWords: "",
          WorkUnit: '',
          City: '',
          Depart: '',
          StationName: '',
          Position: ''
        },
        checked: {},
        activeName: "0",
        mainData: {},
        childrenData: [],

        options: [], //地址
        formStatus: -1,
        formReadOnly: false, //表单只读
        flowRecord: [],
        startDate: '',
        endDate: '',

        // line 专线
        Category: [],
        orderby: [],

        // info
        reload:false, //是否重新加载不弹出提示

        ClintData: {
          "success": true,
          "code": 200,
          "message": "请求成功",
          "total": 6,
          "data": [{
              "rownum": 1,
              "ID": 411935,
              "ReceiverName": "ZHONGR3",
              "MessageTitle": "Happy Birthday~~",
              "MessageContent": "https://admin.srpltradeunion.com/uploadfiles/ecard/47e5d479ec784505bda2396f39df4a02.png",
              "MessageType": "图片",
              "CreationTime": "2022-08-10 09:32:01",
              "IsRead": false,
              "Category": "电子卡消息",
              "Link": "",
              "MsgId": null
            },
            {
              "rownum": 2,
              "ID": 189048,
              "ReceiverName": "ZHONGR3",
              "MessageTitle": "致坚守在园区的英雄们",
              "MessageContent": "https://admin.srpltradeunion.com/uploadfiles/ecard/9d478e78e4d24600bf0cbccb1d4f1990.png",
              "MessageType": "图片",
              "CreationTime": "2022-04-06 14:37:01",
              "IsRead": true,
              "Category": "电子卡消息",
              "Link": "",
              "MsgId": null
            },
            {
              "rownum": 3,
              "ID": 176613,
              "ReceiverName": "ZHONGR3",
              "MessageTitle": "新年快乐",
              "MessageContent": "https://admin.srpltradeunion.com/uploadfiles/ecard/f4b858ba4ad84893afc2424000313af5.png",
              "MessageType": "图片",
              "CreationTime": "2022-03-30 15:20:02",
              "IsRead": true,
              "Category": "电子卡消息",
              "Link": "",
              "MsgId": null
            },
            {
              "rownum": 4,
              "ID": 176610,
              "ReceiverName": "ZHONGR3",
              "MessageTitle": "新年快乐",
              "MessageContent": "https://admin.srpltradeunion.com/uploadfiles/ecard/c78d53e206e941c8a50d057dc7e30c7e.png",
              "MessageType": "图片",
              "CreationTime": "2022-03-30 11:47:01",
              "IsRead": true,
              "Category": "电子卡消息",
              "Link": "",
              "MsgId": null
            },
            {
              "rownum": 5,
              "ID": 176608,
              "ReceiverName": "ZHONGR3",
              "MessageTitle": "新年快乐",
              "MessageContent": "https://admin.srpltradeunion.com/uploadfiles/ecard/0ce2e691962e41988cc305b3b8e33017.png",
              "MessageType": "图片",
              "CreationTime": "2022-03-30 11:40:02",
              "IsRead": true,
              "Category": "电子卡消息",
              "Link": "",
              "MsgId": null
            },
            {
              "rownum": 6,
              "ID": 176597,
              "ReceiverName": "ZHONGR3",
              "MessageTitle": "新年快乐",
              "MessageContent": "https://admin.srpltradeunion.com//uploadfiles/ecard/cd12ee5462a74ad08d871f1fd3a218a7.png",
              "MessageType": "图片",
              "CreationTime": "2022-03-30 11:09:01",
              "IsRead": true,
              "Category": "电子卡消息",
              "Link": "",
              "MsgId": null
            }
          ]
        }
      };
    },
    mounted() {
      //添加滚动事件，检测滚动到页面底部
      window.addEventListener("scroll", this.scrollBottom);
    },
    computed: {
      ...mapState("d2admin/menu", ["header"]),
      ...mapState("d2admin/list", ["info"]),
      ...mapState("d2admin/userInfo", ["userinfo"]),
      ...mapState("d2admin/page", ["current"]),
    },
    watch: {
      $route: {
        handler(val) {
          this.header.forEach((v) => {
            if (v.path == val.path) {
              let uInfo = this.userinfo.uInfo;
              let menu = v.menu;
              if (uInfo.Role && uInfo.Role.indexOf("职代会") != -1) {
                this.menu = menu;
              } else {
                let arr2 = ['工会发布列表', "职代会代表专线", "代表职责", "我的发布", '我的评论'];
                menu = _.filter(menu, function (o) {
                  return !arr2.includes(o.title)
                });
              }

              if (uInfo.Role && (uInfo.Role.indexOf("工会主席") != -1 || uInfo.Role.indexOf("主席助理") != -1)) {
                this.menu = menu;
              } else {
                menu = _.filter(menu, function (o) {
                  return o.title != "未回复列表";
                });
              }

              if (uInfo.RoleName && (uInfo.RoleName.indexOf("预备会员") != -1) && uInfo.MemberStatus!=1) {
                this.menu = menu;
              } else {
                menu = _.filter(menu, function (o) {
                  return o.title != "入会申请";
                });
              }


              this.menu = menu
              if (this.info.active == v.active) {
                let info = {}
                if (this.info.active == this.active) {
                  info = {
                    active: v.active,
                    name: this.menu[v.active].title,
                    enName: this.menu[v.active].enTitle,
                    type: this.menu[v.active].type,
                    code: this.menu[v.active].code,
                  };
                } else {
                  info = {
                    active: this.active,
                    name: this.menu[this.active].title,
                    enName: this.menu[this.active].enTitle,
                    type: this.menu[this.active].type,
                    code: this.menu[this.active].code,
                  };
                }
                this.set(info);
              } else {
                //新增
                let flag = this.menu.some((m) => m.title === this.menuselect);
                let index = this.menu.findIndex(fileItem => {
                  return fileItem.title === this.menuselect
                });
                let info = {}
                if (flag && index != -1) {
                  info = {
                    active: index,
                    name: this.menu[index].title,
                    enName: this.menu[index].enTitle,
                    type: this.menu[index].type,
                    code: this.menu[index].code,
                  };
                } else {
                  if (v.active == this.active) {
                    info = {
                      active: this.info.active,
                      name: this.menu[this.info.active].title,
                      enName: this.menu[this.info.active].enTitle,
                      type: this.menu[this.info.active].type,
                      code: this.menu[this.info.active].code,
                    };
                  } else {
                    info = {
                      active: this.active,
                      name: this.menu[this.active].title,
                      enName: this.menu[this.active].enTitle,
                      type: this.menu[this.active].type,
                      code: this.menu[this.active].code,
                    };
                  }
                }
                this.set(info);
              }
              this.getActiveList(this.info);
            }
          });
        },
        immediate: true,
      },
    },
    created() {},
    methods: {
      ...mapActions("d2admin/list", ["set"]),
      //类型按钮切换 并vuex
      changeHandle(active, title, enTitle, type, code) {
        let info = {
          active: active,
          name: title,
          enName: enTitle,
          type: type,
          code: code,
        };
        this.set(info);
        if (info.type == "list") {
          this.pageIndex = 0;
          this.startDate = '';
          this.endDate = '';
          this.ListData = [];
          this.readData = [];
        } else if (info.type == "richText" && info.code == "rule") {
          this.pageIndex = 0;
        }
        this.getActiveList(this.info);
      },
      //滚底加载
      scrollBottom() {
        this.loading = false;
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let clientHeight = document.documentElement.clientHeight;
        let scrollHeight = document.documentElement.scrollHeight;
        let bottomOfWindow = parseInt(scrollTop + clientHeight) == scrollHeight;
        if (
          scrollTop != 0 &&
          bottomOfWindow &&
          this.loading == false &&
          this.finished == false
        ) {
          this.loading = true;
          this.getActiveList(this.info);
        }
      },
      //搜索
      handleSearchFormSubmit: _.debounce(
        function (search) {
          this.pageIndex = 0;
          this.getActiveList(this.info);
        },
        1000, {
          leading: true,
          trailing: false,
        }
      ),
      // 传参搜索关键词
      handleSearchSubmit(pages, search) {
        this.pageIndex = pages;
        if (typeof (search) == 'string') {
          this.searchForm.keyWords = search;
        } else {
          this.searchRosterForm.keyWords = search.keyWords;
          this.searchRosterForm.WorkUnit = search.WorkUnit;
          this.searchRosterForm.City = search.City;
          this.searchRosterForm.Depart = search.Depart;
          this.searchRosterForm.StationName = search.StationName;
          this.searchRosterForm.Position = search.Position;
        }
        this.getActiveList(this.info);
      },
      handleSearchLine(pages, search) {
        this.pageIndex = pages;
        this.ListData = [];
        this.readData = [];
        if (search.Category) {
          this.Category.push({key:"Category",value:search.Category,sqlOperator:"EN"})
        }else{
          this.Category =[]
        }

        this.orderby = search.sort
        
        this.searchForm.keyWords = search.keyWords;
        
        this.getActiveList(this.info, this.Category, this.orderby);
      },
      // 传参搜索 切换年份
      handleSearchYearSubmit(pages, search) {
        this.pageIndex = pages;
        this.searchForm.searchYear = search;
        this.getActiveList(this.info);
      },
      handleSearchYearSubmit1(pages, startDate, endDate) {
        this.pageIndex = pages;
        this.startDate = startDate;
        this.endDate = endDate;
        this.getActiveList(this.info);
      },
      //tab切换搜索
      handleClick() {
        this.pageIndex = 0;
        this.getActiveList(this.info);
      },
      handlePublish() {
        this.pageIndex = 0;
        this.getActiveList(this.info);
      },
      //消息已读重新加载
      messageReloadHandle() {
        this.pageIndex = 0;
        this.getActiveList(this.info);
      },
      MemberInfoHandle(flag) {
        this.getActiveList(this.info);
        this.reload=flag
      },
      //获取api
      getActiveList: _.debounce(
        function (info, Category, orderby) {
          console.log(1111111111111)
          this.loading = true;
          let action = "";
          this.$apilist.forEach((v) => {
            if (info.name == v.name) {
              this.checked = v;
              if (v.tabs) {
                v.tab.forEach((i) => {
                  if (v.active == i.active) {
                    action = i.action;
                    v = i;
                  }
                });
              } else {
                action = v.action;
              }
              this.pageIndex = this.pageIndex + 1;
              // 列表
              if (info.type == "list") {
                let param = {
                  ...v.param,
                  StationCode: "",
                  filter: [],
                  shortTitle: v.shortTitle,
                  start: this.pageIndex,
                };

                if (v.pageSize) {
                  param = {
                    ...param,
                    limit: v.pageSize,
                  };
                }
                if (v.param) {
                  let pa = v.param;
                  if (pa.hasOwnProperty('orderby') || pa.orderby) {
                    param = {
                      ...param,
                      orderby: pa.orderby,
                    };
                  }

                  if (this.orderby && this.orderby.length>0) {
                    param = {
                      ...param,
                      orderby: this.orderby,
                    };
                  }

                  if (pa.activityStatus) {
                    param = {
                      ...param,
                      activityStatus: pa.activityStatus,
                    };
                  }

                  if (pa.ActivityParton) {
                    param = {
                      ...param,
                      ActivityParton: pa.ActivityParton,
                    };
                  }

                  if (pa.ProcessStatus) {
                    param = {
                      ...param,
                      ProcessStatus: pa.ProcessStatus,
                    };
                  }

                  if (pa.billType) {
                    param = {
                      ...param,
                      billType: pa.billType,
                    };
                  }

                  if (pa.date) {
                    param = {
                      ...param,
                      date: dayjs().startOf("month").format("YYYY-MM-DD"),
                    };
                  }

                  if (pa.type) {
                    param = {
                      ...param,
                      type: pa.type,
                    };
                  }

                  if (pa.my) {
                    param = {
                      ...param,
                      my: pa.my,
                    };
                  }
                }

                // 筛选过滤
                if (v.filter) {
                  if (v.mode == "ghrd") {
                    if(this.searchForm.keyWords){
                      let filter=[{key: "ComeFrom",value:"移动端",sqlOperator:"EN",sqlLogic:"and",filter:[{key:"MemberName",value:this.searchForm.keyWords,sqlOperator:"FF",sqlLogic:"or"},{key:"Subject",value:this.searchForm.keyWords,sqlOperator:"FF"}]}]
                      param.filter=[...param.filter,...filter]
                    }else{
                      param.filter.push({key:"ComeFrom",value:"移动端",sqlOperator:"EN"})
                    }
                  } else {
                    param.filter=[...param.filter,...this.filterArraryReplace(v.filter)]
                  }
                }

                if (this.Category) {
                  param.filter=[...param.filter,...this.Category]
                }

                if (v.filterMe) {
                  param.filter.push({key:"CustomFormConfig.Writer",value:this.userinfo.uInfo.Code,sqlOperator:"EN"})
                }
                if (v.filterScreen) {
                  // param.fiter += " and " + this.screenReplace(v.filterScreen);
                }
                if (v.filterNeedStationCode) {
                  // param.fiter +=
                  //   ` and dbo.GetUnionShowStatus('${this.userinfo.uInfo.Code}',StationCode,'${this.userinfo.uInfo.StationCode}')=1`;
                  //   param.filter.push({"key":"GetUnionShowStatus|StationCode",value:this.userinfo.uInfo.Code,"sqlOperator":"FUN"});
                }
                if (v.filterNotPush) {
                  // param.fiter += " and " + this.notPushReplace(v.filterNotPush);
                }
                if (v.filterYear) {
                  param.filter.push({key:"Year(CreateTime)",value:this.searchForm.searchYear,sqlOperator:"EN"})
                }
                if (v.search) {
                  let filter=[{key:"Title",value:this.searchForm.keyWords,sqlOperator:"FF",sqlLogic:"or"},{key:"Content",value:this
                    .searchForm.keyWords,sqlOperator:"FF"}]
                  param.filter=[...param.filter,{key:"1",value:"1",sqlOperator:"EN",filter:filter}]
                }
                if (v.mode == "score" || v.mode == "cash" || v.mode == "fuli" || v.mode == "duihuan") {
                  let year = dayjs().year();
                  let startDate = this.startDate ? this.startDate : dayjs(year + "-01-01").format("YYYY-MM-DD");
                  let endDate = this.endDate ? this.endDate : dayjs().format("YYYY-MM-DD");
                  // param.filter.push({key:"startDate",value:startDate,sqlOperator:"EN"})
                  // param.filter.push({key:"endDate",value:endDate,sqlOperator:"EN"})
                  param.startDate = startDate;
                  param.endDate = endDate;
                }
                if (v.mode == "myDh") {
                  let startDate = this.startDate ? this.startDate : dayjs().startOf('month').format(
                    "YYYY-MM-DD");
                  let endDate = this.endDate ? this.endDate : dayjs().format("YYYY-MM-DD");
                  param.filter.push({key:"startDate",value:startDate,sqlOperator:"EN"})
                  param.filter.push({key:"endDate",value:endDate,sqlOperator:"EN"})
                }

                if (v.searchSelect) {
                  Object.keys(this.searchRosterForm).forEach(v => {
                    if (this.searchRosterForm[v]) {
                      let obj={}
                      obj={
                        key:v,
                        value:this.searchRosterForm[v],
                        sqlOperator:"EN"
                      }
                      param.filter.push(obj)
                    }
                  })
                }
                //
                indexService.getActiveDataList(action, param).then((data) => {
                  this.total = data.total;
                  this.pageIndex == 1 ? (this.ListData = []) : this.ListData;
                  this.pageIndex == 1 ? (this.readData = []) : this.readData;
                  this.ListData.push(...data.data);

                  if (this.checked.slot == 'dzCrad') {
                    this.total = this.ClintData.total;
                    this.ListData = this.ClintData.data.map(v => {
                      var srcList = [];
                      srcList.push(v.MessageContent)
                      return {
                        ...v,
                        srcList: srcList
                      }
                    });
                  }

                  if (data.data.length == 0 || param.limit >= this.total) {
                    this.finished = true;
                  } else if (info.code == 'roster') {
                    this.finished = true;
                  } else {
                    this.finished = false;
                  }

                  if (v.isRead) {
                    let configID = [];
                    configID = _.map(this.ListData, "_CONFIG_ID");
                    indexService
                      .getActiveDataList(v.readList.action, {
                        configID,
                      })
                      .then((data) => {
                        this.readData = _.merge(this.ListData, data.data);
                        this.loading = false;
                      });
                  } else if (v.isAgree) {
                    if (data.data.length == 0) {
                      this.loading = false;
                      this.readData = this.ListData;
                    } else {
                      let list = JSON.parse(JSON.stringify(data.data));
                      list.map(obj => {
                        let param = {};
                        param = {
                          DataId: obj.ID,
                          TemplateId: obj._TEMPLATE_ID,
                        };
                        indexService
                          .getActiveDataList(v.agreeList.action, param)
                          .then((data) => {
                            this.$set(obj, 'agreeType', data.agreeType)
                            this.$set(obj, 'count', data.count)
                          });
                        this.loading = false;
                        this.readData.push(obj)
                      })
                    }
                  } else {
                    this.loading = false;
                    this.readData = this.ListData;
                  }
                }).catch(e=>{
                  this.loading = false;
                });
              } else if (info.type == "richText") {
                if (info.code == "pdf" || info.code == "pdfOpera") {
                  //pdf展示
                  let param = {
                    filter: [],
                    shortTitle: v.shortTitle,
                    detailed: false,
                  };
                  if (v.filter) {
                    param.filter=[...param.filter,...this.filterArraryReplace(v.filter)]
                  }
                  indexService.getActiveDataList(action, param).then((data) => {
                    this.content = JSON.stringify(data.data);
                    this.finished = true
                  });
                } else if (info.code == "duty") {
                  //代表职责
                  let param = {
                    filter: [],
                    shortTitle: v.shortTitle,
                    detailed: false,
                  };
                  if (v.filter) {
                    param.filter=[...param.filter,...this.filterArraryReplace(v.filter)]
                  }
                  indexService.getActiveDataList(action, param).then((data) => {
                    this.content = JSON.stringify(data.data);
                  });
                } else if (info.code == "rule") {
                  //福利规则
                  let param = {
                    orderby: [{columnName:"SortIndex",sortType:""}],
                    shortTitle: v.shortTitle,
                    start: this.pageIndex,
                  };
                  if (v.filterTypeName == true) {
                    param = {
                      ...param,
                      filter: [{key:"TypeName",value:v.name,sqlOperator:"EN"}],
                    };
                  }
                  if (v.filterName == true) {
                    param = {
                      ...param,
                      filter: [{key:"Name",value:v.name,sqlOperator:"EN"}],
                    };
                  }
                  if (v.pageSize) {
                    param = {
                      ...param,
                      limit: v.pageSize,
                    };
                  }
                  indexService.getActiveDataList(action, param).then((data) => {
                    this.finished = true;
                    this.content = JSON.stringify(data.data);
                  });
                }
              } else if (info.type == "form") {
                if (info.code == "info") {
                  //会员信息
                  /**
                   * 预备会员：   获取状态  GetMemberApplyStatus
                   * -2  当前用户已经是会员  无法修改（提交按钮无法点击）        
                   * -4  实习生不能入会（提交按钮正常点击）            GetMemberInfo
                   * -3  不满3个月                                    GetMemberInfo
                   * -1  未申请入会  
                   * 0   审批中（已提交无提交按钮， 加崔撤销申请）     GetMemberApply
                   * 1   审批通过
                   * 3   关系不满足
                   * 
                   * 正式会员：   获取状态  GetMemberChangeStatus
                   * -2  无权限  无法修改（提交按钮无法点击）    GetMemberChange       
                   * -1 没有提交（提交按钮正常点击）             GetMemberInfo
                   * 0 正常（已提交无提交按钮， 加崔撤销申请）   GetMemberInfo
                   * 
                   * 预备会员提交为申请入会AddMemberApply     修改预备会员信息为UpdateMemberApply
                   * 正式会员提交为修改信息AddMemberChange
                   * 
                   * 正式会员 状态为0下拿取流程
                   * 预备会员 状态不为-1下拿去流程
                   */
                  
                  let RoleName = this.userinfo.uInfo.RoleName
                  // console.log(RoleName)
                  if (RoleName == '正式会员' || RoleName.indexOf('正式会员') != -1) {
                    indexService.getActiveDataList(action).then((data) => {
                      this.finished = true;
                      this.formStatus = data.data.status;
                      if (data.data.status == -1) {
                        this.formReadOnly = false;
                        this.GetMemberInfo('123', true);
                        this.loading = false;
                      } else {
                        var {
                          DataId,
                          TemplateId
                        } = data.data;
                        // 已有单子  拿取单子数据 然后 拿流程
                        var message = "";
                        var {
                          MemberStatus
                        } = this.userinfo.uInfo;
                        switch (MemberStatus) {
                          case 1:
                            message = "入职未满三个月，暂时无法修改。";
                            break;
                          case 2:
                            message = "未完成入会申请，请在流程结束后修改。";
                            break;
                          case 3:
                            message = "信息审批中，请先撤回再修改。";
                            break;
                          case 4:
                            message = "信息审批中，请等待流程完毕。";
                            break;
                        }
                        if (data.data.status == -2) {
                          // message = res.data.Actor
                        } else if (data.data.status == 1) {
                          message = null;
                        } else {
                          message = `该账号已提交申请,当前:${data.data.Actor}\n信息审批中，请等待流程完毕。`;
                        }
                        !this.reload && DataId && message ? this.$message.warning(message) : null
                        if (data.data.status == 0) {
                          this.formReadOnly = true;
                          this.GetMemberChange('123');
                        } else {
                          this.formReadOnly = false;
                          this.GetMemberInfo('123', true);
                        }

                      }
                    });
                  } else { //预备会员 实习生
                    indexService.GetMemberApplyStatus().then((data) => {
                      this.finished = true;
                      this.formStatus = data.data.status;
                      // 如果实习生与 预备会员未满三个月  formReadOnly为true
                      // if(RoleName=='实习生' || (RoleName=='预备会员' && this.userinfo.uInfo.MemberStatus==2)){
                      //   this.formReadOnly = true;
                      // }
                      if (data.data.status == -1) { // 未申请
                        this.GetMemberInfo('rhsq');
                        this.loading = false;
                      } else {
                        var message = data.data.status == -2 ? data.data.Actor : data.data.status == 1 ?
                          "该账号申请已完成" : data.data.status == 0 ?
                          `该账号已提交申请,当前:${data.data.Actor}\n信息审批中，请等待流程完毕` : data.data.status == -3 ?
                          '预备会员未满3个月，请满3个月之后申请。' : `${data.data.Actor}`;
                        this.$message.warning(message);
                        if (data.data.status == 0) {
                          this.GetMemberApply();
                        } else {
                          this.formReadOnly = true;
                          this.GetMemberInfo('rhsq', true);
                        }
                        this.loading = false;
                      }
                    });
                  }
                } else if (info.code == 'publish') {
                  indexService.GetIsMember().then((data) => {
                    if (data.data.isMember == false) {
                      this.$message.warning("此账号不是会员,无法发布");
                    }
                    this.formStatus = data.data.isMember
                    this.loading = false;
                  });
                }
              }
            }
          });
          if (info.code == "letter") {
            this.content = richTextData.LETTER_TEXT;
          }
        },
        10, {
          leading: true,
          trailing: false,
        }
      ),
      // 会员信息
      GetMemberInfo(type, flow = false) {
        let param = {
          shortTitle: "人员信息表",
          type: type
        }
        indexService.GetMemberInfo(param).then((data) => {
          this.mainData = data.data.mainData;
          this.childrenData = data.data.childrenData;
          this.GetCityData1();
          if (flow == true) {
            this.GetWorkflowRecord(
              this.mainData.ID,
              this.mainData._TEMPLATE_ID
            );
          }
        });
      },
      GetMemberApply() {

        indexService.GetMemberApply().then((data) => {
          this.mainData = data.data.mainData;
          this.childrenData = data.data.childrenData;
          this.GetCityData1();
          this.GetWorkflowRecord(
            this.mainData.ID,
            this.mainData._TEMPLATE_ID
          );
        });
      },
      GetMemberChange(type, flow = false) {
        let param = {
          shortTitle: "人员信息表",
          type: type
        }
        indexService.GetMemberChange(param).then((data) => {
          this.mainData = data.data.mainData;
          this.childrenData = data.data.childrenData;
          this.GetCityData1();
          this.GetWorkflowRecord(
            this.mainData.ID,
            this.mainData._TEMPLATE_ID
          );
        });
      },
      // 流程
      GetWorkflowRecord(id, temId) {
        let parmas = {
          dataId: id,
          templateId: temId,
        };
        indexService.GetWorkflowRecord(parmas).then((data) => {
          this.flowRecord = data.data;
          this.loading = false;
        });
      },
      //城市信息
      GetCityData1() {
        indexService.GetCityData1().then((data) => {
          let value = _.findIndex(data, ["text", "已选"]);
          if (value == -1 && this.mainData.City) {
            data.data.push({
              text: "已选",
              id: "已选",
              children: [{
                text: this.mainData.City,
                id: this.mainData.City,
              }, ],
            });
          }
          this.options = data.data;
        });
      }
    },
    beforeDestroy() {
      // 页面销毁滚动事件
      window.removeEventListener("scroll", this.scrollBottom)
    },
  };
</script>
<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
</style>